import Logo from "../Assets/logo.png";

// ===================================
// ====== Desktop Notification ======
// ===================================
const ShowDesktopNotification = (name, department, message, link) => {
    const notification = new Notification(
        `New Message From ${name} - ${department}`,
        {
            body: message,
            icon: Logo,
        }
    );
    console.log(window.location.origin + "/messages/" + link);
    notification.onclick = () => {
        window.location.href = window.location.origin + "/messages/" + link;
    };
};
const GetNotificationPermission = (name, department, message, link) => {
    if (Notification.permission === "granted") {
        ShowDesktopNotification(name, department, message, link);
    } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((ress) => {
            if (Notification.permission === "granted") {
                ShowDesktopNotification(name, department, message, link);
            }
        });
    }
};

const DesktopNotification = (name, department, body, link) => {
    GetNotificationPermission(name, department, body, link);
};

export default DesktopNotification;
